import PropTypes from 'prop-types';
import { BsBuilding, BsGeoAlt } from 'react-icons/bs';

import Card from '#globalComponents/Card/Card';
import Tag from '#globalComponents/Tag/Tag';

import CompanyKindBadge from '../CompanyKind/CompanyKindBadge';

const CompanyDetailHeader = ({ company, vocabulary, actions }) => {
	const address = [company.addressStreet, company.addressPostal, company.addressCity].filter(Boolean).join(', ');
	const wzCode = company.industryCodes?.[0];

	return (
		<Card className="mb-4 flex flex-wrap items-start gap-4">
			<div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-control bg-primary-100 text-primary-600">
				<BsBuilding className="h-6 w-6" />
			</div>
			<div className="min-w-0 flex-1">
				<div className="flex flex-wrap items-center gap-2">
					<h1 className="truncate text-lg font-bold text-text">{company.companyName}</h1>
					{company.legalForm && <Tag label={company.legalForm} tone="primary" />}
					<CompanyKindBadge company={company} vocabulary={vocabulary} />
					{company.rating && (
						<Tag
							label={`★ ${company.rating.toFixed(1)}${company.reviewCount > 0 ? ` (${company.reviewCount})` : ''}`}
							tone="caution"
						/>
					)}
				</div>
				{(address || wzCode || company.operatingCompanyName) && (
					<div className="mt-1.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-bgBase-800">
						{address && (
							<span className="flex items-center gap-1">
								<BsGeoAlt className="h-3.5 w-3.5" />
								{address}
							</span>
						)}
						{wzCode && <span>WZ {wzCode}</span>}
						{company.operatingCompanyName && <span>Operative Firma: {company.operatingCompanyName}</span>}
					</div>
				)}
			</div>
			{actions && <div className="flex flex-shrink-0 items-center gap-2">{actions}</div>}
		</Card>
	);
};

CompanyDetailHeader.propTypes = {
	company: PropTypes.object.isRequired,
	vocabulary: PropTypes.object,
	actions: PropTypes.node,
};

export default CompanyDetailHeader;
